<script setup lang="ts">
  import { type HTMLAttributes } from 'vue'
  import { useModalContext } from './Modal.vue'
  import { cn } from '../../lib/utils'

  const props = defineProps<{
    class?: HTMLAttributes['class']
  }>()

  const { modalType } = useModalContext()
</script>

<template>
  <div :data-modal-type="modalType" :class="cn('flex-1 py-5', props.class)">
    <slot />
  </div>
</template>
